import { render, staticRenderFns } from "./NewPublishingScheduleAction.vue?vue&type=template&id=65401f12&scoped=true&"
import script from "./NewPublishingScheduleAction.vue?vue&type=script&lang=js&"
export * from "./NewPublishingScheduleAction.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65401f12",
  null
  
)

export default component.exports